var _title, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcSettings = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "kavabaga12")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "kavabaga1",
    x: 0,
    y: 0,
    width: 1280,
    height: 885
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-0.4%",
    y: "-0.5%",
    width: "100.8%",
    height: "101.1%",
    filterUnits: "objectBoundingBox",
    id: "kavabaga2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "shadowSpreadOuter2",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.12 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter3",
    result: "shadowBlurOuter3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.14 0",
    type: "matrix",
    in: "shadowBlurOuter3",
    result: "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter3"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M16.1916667,10.8166667 C16.225,10.55 16.25,10.2833333 16.25,10 C16.25,9.71666667 16.225,9.45 16.1916667,9.18333333 L17.95,7.80833333 C18.1083333,7.68333333 18.15,7.45833333 18.05,7.275 L16.3833333,4.39166667 C16.2833333,4.20833333 16.0583333,4.14166667 15.875,4.20833333 L13.8,5.04166667 C13.3666667,4.70833333 12.9,4.43333333 12.3916667,4.225 L12.075,2.01666667 C12.05,1.81666667 11.875,1.66666667 11.6666667,1.66666667 L8.33333333,1.66666667 C8.125,1.66666667 7.95,1.81666667 7.925,2.01666667 L7.60833333,4.225 C7.1,4.43333333 6.63333333,4.71666667 6.2,5.04166667 L4.125,4.20833333 C3.93333333,4.13333333 3.71666667,4.20833333 3.61666667,4.39166667 L1.95,7.275 C1.84166667,7.45833333 1.89166667,7.68333333 2.05,7.80833333 L3.80833333,9.18333333 C3.775,9.45 3.75,9.725 3.75,10 C3.75,10.275 3.775,10.55 3.80833333,10.8166667 L2.05,12.1916667 C1.89166667,12.3166667 1.85,12.5416667 1.95,12.725 L3.61666667,15.6083333 C3.71666667,15.7916667 3.94166667,15.8583333 4.125,15.7916667 L6.2,14.9583333 C6.63333333,15.2916667 7.1,15.5666667 7.60833333,15.775 L7.925,17.9833333 C7.95,18.1833333 8.125,18.3333333 8.33333333,18.3333333 L11.6666667,18.3333333 C11.875,18.3333333 12.05,18.1833333 12.075,17.9833333 L12.3916667,15.775 C12.9,15.5666667 13.3666667,15.2833333 13.8,14.9583333 L15.875,15.7916667 C16.0666667,15.8666667 16.2833333,15.7916667 16.3833333,15.6083333 L18.05,12.725 C18.15,12.5416667 18.1083333,12.3166667 17.95,12.1916667 L16.1916667,10.8166667 L16.1916667,10.8166667 Z M10,12.9166667 C8.39166667,12.9166667 7.08333333,11.6083333 7.08333333,10 C7.08333333,8.39166667 8.39166667,7.08333333 10,7.08333333 C11.6083333,7.08333333 12.9166667,8.39166667 12.9166667,10 C12.9166667,11.6083333 11.6083333,12.9166667 10,12.9166667 L10,12.9166667 Z",
    id: "kavabaga15"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "kavabaga14",
    x: 0,
    y: 0,
    width: 41.6666667,
    height: 41.6666667
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kavabaga3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kavabaga4",
    transform: "translate(-357.000000, -171.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 1440,
    height: 1024
  }), /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    stroke: "#DFE2E5",
    fill: "#F7F8FA",
    x: -0.5,
    y: 123.5,
    width: 1441,
    height: 901
  }), /*#__PURE__*/React.createElement("g", {
    id: "kavabaga5",
    transform: "translate(80.000000, 139.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kavabaga7"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#kavabaga2)",
    xlinkHref: "#kavabaga1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#kavabaga1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "kavabaga6",
    transform: "translate(0.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kavabaga6-11",
    transform: "translate(276.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kavabaga12",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "kavabaga11",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kavabaga15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "kavabaga8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "kavabaga6",
    mask: "url(#kavabaga11)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10.833333, -10.833333)",
    id: "kavabaga9"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "kavabaga10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kavabaga14"
  })), /*#__PURE__*/React.createElement("use", {
    id: "kavabaga13",
    fill: "#BEC4CA",
    xlinkHref: "#kavabaga14"
  })))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcSettings, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-settings.7d353922.svg";
export { ForwardRef as ReactComponent };